import React from 'react';
import '../styles/LatestWork.css';

const LatestWork = () => {
  return (
    <section className="latest-work">
      <div className="latest-work-container">
        <div className="video-wrapper">
          <div className="video-info">
            <h2 className="section-title-left">Latest Work</h2>
            <h3 className="video-title">Beach Chair, Towels, and Cooler</h3>
            <p className="video-date">Prop Design</p>
          </div>
          <div className="video-container">
            <img
              src="/prop-beach-chair.png"
              alt="Beach Chair, Towels, and Cooler"
              className="video-thumbnail latest-work-prop"
              data-testid="latest-work-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestWork;
